import React from "react";

import "./logoutButton.scss";

const LogoutButton = ({ text, logout }: any) => (
    <div className="logout-button">
        <a
            className="usp-bar__item"
            onClick={e => {
                e.preventDefault();
                logout();
            }}
        >
            <div className="usp-bar__item-icon ">
                <i className="las la-undo" />
            </div>
            <div className="usp-bar__item-description body-copy-1">{text}</div>
        </a>
    </div>
);

export default LogoutButton;
